import { Answer, Api as AnswersApi } from '@legalshield/frontend-commons-fetch/answers';
import { SDKHeaders } from '@legalshield/frontend-commons-fetch/utils';

import { SubmitAnswersError } from '../errors/SubmitAnswers.error';

const answersApi = new AnswersApi();

const submitAnswer = async (version: number | undefined, id: string): Promise<Answer> => {
  const response = await answersApi.v1.publicAnswersSubmitAnswer(
    'b6a1053b-fc01-4acc-9689-768609f4f2d9',
    id,
    SDKHeaders.getVersionConfig(String(version ?? 0)),
  );

  if (!response.ok) {
    throw new SubmitAnswersError();
  }

  return response.data;
};

export default submitAnswer;
